import { useLang } from "@/context/LangContext";
import { LANGS } from "@/lib/i18n";
import { DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem } from "@/components/ui/dropdown-menu";
import { Languages } from "lucide-react";

export default function LangSwitcher() {
  const { lang, setLang } = useLang();
  const current = LANGS.find((l) => l.code === lang) || LANGS[0];

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          data-testid="lang-switcher"
          className="hidden md:inline-flex items-center gap-1.5 px-3 py-2 rounded-full border border-[#E2DCD0] text-sm font-semibold text-[#13294B] hover:border-[#13294B] transition-colors"
          aria-label="Language"
        >
          <Languages className="w-4 h-4" />
          <span>{current.label}</span>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="bg-white">
        {LANGS.map((l) => (
          <DropdownMenuItem
            key={l.code}
            data-testid={`lang-${l.code}`}
            onClick={() => setLang(l.code)}
            className={l.code === lang ? "font-bold text-[#E25A24]" : ""}
          >
            {l.name}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
